import type stockAdjustmentId from "./id";

const stockAdjustmentEn: typeof stockAdjustmentId = {
	stock_adjustment: {
		title: "Stock Adjustment",
		subtitle: "Summary of stock adjustment list",
	table: {
		title: "Stock Out Data",
		columns: {
			date: "Date",
			ref_id: "Ref ID",
			store: "Store",
			notes: "Notes",
			created_by: "Created By",
			status: "Status",
		},
	},
		empty_state: {
			title: {
				has_filter: "No matching data",
				no_filter: "No Stock Adjustment Data",
			},
			description: {
				has_filter:
					"No data found with the selected filters. Please try changing your filters.",
				no_filter: "Please add new Stock Adjustment.",
			},
		},
		forms: {
			edit: {
				title: "Edit Stock Adjustment",
				info: "Stock adjustment information",
				fields: {
					ref_id: {
						label: "RefId",
						placeholder: "refId",
					},
					store: {
						label: "Store",
						placeholder: "Select Store",
					},
					notes: {
						label: "Notes",
						placeholder: "notes",
					},
					status: {
						label: "Status",
						placeholder: "Select Status",
					},
				},
				options: {
					active: "Active",
					inactive: "Inactive",
				},
			},
			add: {
				button: "Add Stock Adjustment",
				title: "Add Stock Adjustment",
				description: "Add new Stock Adjustment",
				fields: {
					store: {
						label: "Store",
						placeholder: "Choose store",
					},
					notes: {
						label: "Notes",
						placeholder: "Enter Notes",
					},
					processed_at: {
						label: "Processed at",
					},
					product_detail: {
						title: "Product Detail",
						loading: "Loading products...",
						product: {
							label: "Product",
							placeholder: "Choose Product",
							search_product: "Search Product...",
							not_found_product: "No product found",
						},
						current_stock: {
							label: "Current Stock",
							placeholder: "0",
						},
						adjustment_stock: {
							label: "Stock Adjustment",
							placeholder: "0",
						},
						stock_differences: {
							label: "Differences",
							placeholder: "0",
						},
						unit: {
							label: "Unit",
							placeholder: "Pcs",
						},
						action: {
							label: "Action",
						},
					},
				},
			},
		},
		actions: {
			save: "Save",
			saving: "Saving...",
			cancel: "Cancel",
			save_changes: "Save Changes",
			add_products: {
				already_added: "This product has already been added",
				button: "Add More Product",
			},
		},
		status: {
			processed: "Processed",
			inactive: "Inactive",
			active: "Active",
		},
	},
};

export default stockAdjustmentEn;
